import {CommonContainerConst,commonContainerRegistrations} from '@multipass-common';
import {ServiceClientContainerConsts} from '@multipass-service-ioc';
import {Router} from '@multipass-system';
import {Level, LoggingConfig} from 'esp-js';
import {App,AppBuilder} from 'esp-js-ui';

import {ShellAppConfig} from './app-config';
import {SessionService} from './dal';
import {ShellContainerConsts} from './ioc';
import {createLegalModule} from './legalModule';
import {LocalStorageCache} from './local-storage-cache';
import {isSupportedLocale, LocaleRestoredEvent, LocaleService, SESSION_STORE_ID, SessionEvents, SessionRestoredEvent, ThemeService} from './logic';
import {createNavigationModule} from './navigationModule';
import {createSessionModule} from './sessionModule';

LoggingConfig.defaultLoggerConfig.level = Level.verbose;
LoggingConfig.defaultLoggerConfig.dumpAdditionalDetailsToConsole = true;

export const createAppShell = (): App =>
    AppBuilder.create('multipass-shell-app')
        .withContainerConfiguration(container => {
            container
                .register(CommonContainerConst.shellApi_appConfig, ShellAppConfig)
                .singleton();
            container
                .register(ShellContainerConsts.key_value_cache, LocalStorageCache)
                .inject({resolver: 'literal', value: 'system'})
                .singleton();
            container
                .register(ShellContainerConsts.theme_service, ThemeService)
                .inject(
                    {resolver: 'literal', value: document},
                    ShellContainerConsts.key_value_cache,
                    {resolver: 'literal', value: window.matchMedia('(prefers-color-scheme: dark)')}
                )
                .singleton();
            container
                .register(ShellContainerConsts.locale_service, LocaleService)
                .inject(
                    ServiceClientContainerConsts.multipassPlatformService_platformService,
                    ShellContainerConsts.key_value_cache,
                    {resolver: 'literal', value: window.navigator.language}
                )
                .singleton();
            commonContainerRegistrations(container);
        })
        .withModule(createSessionModule())
        .withModule(createLegalModule())
        .withModule(createNavigationModule())
        .withStart(async app => {
            const localeService = app!.container.resolve<LocaleService>(ShellContainerConsts.locale_service);
            await localeService.load();
            const sessionService = app!.container.resolve<SessionService>(ShellContainerConsts.session_service);
            const session = await sessionService.restoreSession();
            if (session) {
                app!.eventBus.publishEvent(SESSION_STORE_ID, SessionEvents.sessionRestored, {session} satisfies SessionRestoredEvent);
                if (!localeService.supportsStoredOverride && isSupportedLocale(session.locale) && session.locale !== localeService.currentLocale) {
                    await localeService.load(session.locale);
                }
            }
            app!.eventBus.publishEvent(SESSION_STORE_ID, SessionEvents.localeRestored, {locale: localeService.currentLocale} satisfies LocaleRestoredEvent);
            app!.container.resolve<Router>(CommonContainerConst.router).start();
        })
        .build();
